<!--底部组件-->
<template>
  <div class="footer-box">
    Copyright © 2013 - {{nowYear}}
    <span v-html="baseInfo.web_site_copyright"></span>
  </div>
</template>

<script>
  import {ajaxGet,ajaxUrl} from "../utils/ajax";

  export default {
    name: "Footer",
    data() {
      return {
        ajaxUrl,
        baseInfo:{},
        nowYear:new Date().getFullYear(),
      }
    },
    computed: {},
    methods:{
      fetchBase(){
        ajaxGet({
          url: `${this.ajaxUrl}api/common/getConfig`,
          params:{},
          success(res){
            const {code, data, msg} = res;
            if(code === 200) {
              this.baseInfo = data.config_list;
            }
          },
        },this);
      },
    },
    mounted() {
      this.fetchBase();
    },
  }
</script>

<style lang="scss" scoped>
  .footer-box {
    width: 100%;background: rgba($theme-color,.9);color: $color-white;padding: 16px;text-align: center;
  }
  @media screen and (max-width: 750px) {
    .footer-box {
      font-size: 12px;padding: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue